import { Component, OnInit } from '@angular/core'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AcmDashboardPromoDialogService } from '../acm-dashboard-promo-dialog/acm-dashboard-promo-dialog.service'
import { UserStorage } from '@tv3/services/utils/storage.service'

@Component({
  selector: 'app-acm-banner2',
  templateUrl: './acm-banner2.component.html',
  styleUrls: ['./acm-banner2.component.scss'],
})
export class AcmBanner2Component implements OnInit {
  constructor(
    private amp: AmplitudeService,
    private acmDashboardPromoDialog: AcmDashboardPromoDialogService,
    private storage: UserStorage
  ) {}

  ngOnInit(): void {}

  onExploreACM() {
    this.amp.logEvent('acm-dashboard-promo-explore-clicked')
    this.acmDashboardPromoDialog.open()
  }

  onClosePromo() {
    this.amp.logEvent('acm-dashboard-promo-close-clicked')
    this.storage.set('acm_dashboard_promo_dismissed', true)
  }

  isShowACMPromo() {
    return !this.storage.get('acm_dashboard_promo_dismissed', false)
  }
}
